import { render } from "./LdapConfiguration.vue?vue&type=template&id=2bccbfe4&scoped=true"
import script from "./LdapConfiguration.vue?vue&type=script&lang=js"
export * from "./LdapConfiguration.vue?vue&type=script&lang=js"

import "./ldap-configuration.scss?vue&type=style&index=0&id=2bccbfe4&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bccbfe4"]])

export default __exports__